<template>
  <el-image
    class="custom-image"
    v-bind="$attrs"
    :src="src || undefined"
  >
    <template #error v-if="$slots.error" />
    <template #error v-else-if="isEmpty($attrs.src)">
      <div class="error">
        暂无图片
      </div>
    </template>
  </el-image>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { isEmpty } from '@toy/utils';

export default defineComponent({
  name: 'CustomImage',
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      isEmpty
    };
  },
});

</script>
<style lang="scss" scoped>
.custom-image {
  .error {
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: var(--el-bg-color);
    color: #999;
    font-size: 12px;
  }
}
</style>
